export default __webpack_public_path__ + "static/media/state-panel-principal.44b04bab.svg";